import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["mainDashboard", "list", "view", "indicators", "days", "5555", "6666", "7777", "8888", "9999"]

  connect() {
    this.controllerName = `financials--books--receivables--liquidations--dashboard`
  }

  doLiquidationsDashboard() {
    var html = `<div data-${this.controllerName}-target="mainDashboard">
                  <div class="row">
                    <div class="col-12 ml-auto pt-3 pb-1" data-${this.controllerName}-target="days" data-controller="financials--books--receivables--liquidations--days" style="overflow: auto;"></div>
                  </div>
                  <div class="row mt-3">
                    <div class="col-2 px-2" data-${this.controllerName}-target="indicators" data-controller="financials--books--receivables--liquidations--indicators"></div>
                    <div class="col-10 px-2" data-${this.controllerName}-target="list" data-controller="financials--books--receivables--liquidations--billings"></div>
                  </div>
                </div>`

    var controller = this
    new Promise(function (resolve) {
      resolve(controller.getControllerByIdentifier("financials--books--receivables--dashboard--main").contentTarget.innerHTML = html)
    }).then(() => {
      controller.getControllerByIdentifier(`financials--books--receivables--liquidations--days`).doMenuPreloader()
    })
  }

  getControllerByIdentifier(identifier) {
    return this.application.controllers.find(controller => {
      return controller.context.identifier === identifier;
    });
  }

  nameTarget(target) {
    return this.targets.find(target)
  }

  // new Promise(function (resolve) {
  //   resolve()
  // }).then(() => {
  // }) 

}
